var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mapaBrasil)?_c('mapa-brasil'):_c('div',{attrs:{"id":"mapa-area-atuacao"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }